/**
 * DevExtreme (esm/renovation/ui/scheduler/view_model/to_test/views/utils/const.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var VIEWS = {
    DAY: "day",
    WEEK: "week",
    WORK_WEEK: "workWeek",
    MONTH: "month",
    TIMELINE_DAY: "timelineDay",
    TIMELINE_WEEK: "timelineWeek",
    TIMELINE_WORK_WEEK: "timelineWorkWeek",
    TIMELINE_MONTH: "timelineMonth",
    AGENDA: "agenda"
};
export var TIMELINE_VIEWS = {
    timelineDay: true,
    timelineWeek: true,
    timelineWorkWeek: true,
    timelineMonth: true
};
